import axios from 'axios';
import decode from 'jwt-decode';
import AppConfig from '../AppConfig/AppConfig.js';
import {compress, decompress} from 'lz-string';

export default class AuthService {
    // Initializing important variables
    constructor(domain) {
        this.appConfig = new AppConfig();
        this.domain = domain || this.appConfig.getAuthServiceHost(); //'https://gc-auth-svc.azurewebsites.net' // API server domain
        this.fetch = this.fetch.bind(this) // React binding stuff
        this.login = this.login.bind(this)
        this.getProfile = this.getProfile.bind(this)
        this.expiresInMilliseconds = this.expiresInMilliseconds.bind(this);
        this.expirationDateTime = this.expirationDateTime.bind(this);
    }

    async nonLocationLogin(gcid, uid, secret){
        var params = {
            grant_type: 'client_credentials',
            client_id: uid,
            client_secret: secret,
            scope: gcid +  " qainspector qacoreapi notificationapi" // note how multiple audiences (resources) are called by a string with space separating them
        }; 
        const formBody = Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&');
        try {
            var config = {
                method: 'post',
                timeout: 5000,
                url: `${this.domain}/connect/token`,
                data: formBody,
                headers: { "Content-Type": "application/x-www-form-urlencoded" }
            }
            //let fullUrl = 'https://jsonplaceholder.typicode.com/users';
            let fullUrl = `${this.domain}/connect/token`;
            const response = await axios.post( fullUrl, formBody, config);
            console.group("Login Response: ");
            console.log(response);
            console.groupEnd();
            //var response = await fetch(fullUrl);
            if (this.statusOk(response)) {
                //const jsonResponse = await response.json();
                this.setUser(uid);
                this.setGcid(gcid);
                this.setToken(response.data.access_token); // Setting the token in localStorage
                this.setLocation("");
                console.log(response);
                return "ok";
            } else {
                return response.status + response.statusText;
            }
        } catch (error) {
            console.log(error);
            return error;
        }
    }


    async login2(gcid, uid, secret, location){
        var params = {
            grant_type: 'client_credentials',
            client_id: uid,
            client_secret: secret,
            scope: gcid +  " qainspector qacoreapi notificationapi" // note how multiple audiences (resources) are called by a string with space separating them
        }; 
        const formBody = Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&');
        try {
            var config = {
                method: 'post',
                timeout: 5000,
                url: `${this.domain}/connect/token`,
                data: formBody,
                headers: { "Content-Type": "application/x-www-form-urlencoded" }
            }
            //let fullUrl = 'https://jsonplaceholder.typicode.com/users';
            let fullUrl = `${this.domain}/connect/token`;
            const response = await axios.post( fullUrl, formBody, config);
            console.group("Login Response: ");
            console.log(response);
            console.groupEnd();
            //var response = await fetch(fullUrl);
            if (this.statusOk(response)) {
                //const jsonResponse = await response.json();
                this.setUser(uid);
                this.setGcid(gcid);
                this.setToken(response.data.access_token); // Setting the token in localStorage
                this.setLocation(location);
                console.log(response);
                return response;
            } else {
                return new Error(response.status + response.statusText);
            }
        } catch (error) {
            console.log(error);
            return new Error(error);
        }
    }

    statusOk(response) {
        return (response.status >= 200 && response.status < 300);
    }


    login(gcid, uid, secret, location) {
        var params = {
            grant_type: 'client_credentials',
            client_id: uid,
            client_secret: secret,
            scope: gcid +  " qainspector qacoreapi notificationapi"
            //scope: gcid +  " obsqainspect adapter" // note how multiple audiences (resources) are called by a string with space separating them
        }; 
        const formBody = Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&');
        return fetch(`${this.domain}/connect/token`, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            method: 'post',
            body: formBody
          })
          .then(res => this._checkStatus(res))
          .then(checkedRes => checkedRes.json())
          .then(jsonRes => {
            this.setUser(uid);
            this.setGcid(gcid);
            this.setToken(jsonRes.access_token); // Setting the token in localStorage
            this.setLocation(location);
            return Promise.resolve(jsonRes);
        })
        .catch((error) => {
          console.log(error);
          this.logout();
          return Promise.reject(error);
        });
    }

    _checkStatus(response) {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300){ // Success status lies between 200 to 300
            return response;
        }  
        else {
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }

    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken() // GEtting token from localstorage
        return !!token && !this.isTokenExpired(token) // handwaiving here
    }

    getTokenPayload(token){
        const decoded = decode(token);
        return {"exp": decoded.exp, 
            "expired": (decoded.exp < Date.now() / 1000),
            "name": decoded.name,
            "scope": decoded.scope
        }
    }

    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return true;
        }
    }

    expirationDateTime(){
        //in milliseconds
        var profile = this.getProfile();
        return profile.exp * 1000;
    }

    expiresInMilliseconds(){
        var profile = this.getProfile();
        var expireDtTime = new Date(profile.exp*1000);
        var now = new Date();
        var result = expireDtTime.getTime() - now.getTime();
        return result;
    }

    setKey(key, val){
        localStorage.setItem(key, val);
    }

    getKey(key){
        return localStorage.getItem(key);
    }

    keyExists(key){
        return (this.getKey(key)!=null);
    }

    
    
    setUser(user){
        localStorage.setItem('user', user);
        //localStorage.setItem('user_gcid', gcid);
    }

    getUser(){
        return localStorage.getItem('user');
        //return localStorage.getItem('user_gcid');
    }
    

    setLocation(location){
        localStorage.setItem('user_qa_location', location)
    }

    getLocation(){
        return localStorage.getItem('user_qa_location');
    }

    setGcid(gcid){
        localStorage.setItem('user_qa_gcid', gcid);
    }

    getGcid(){
        //console.log("gcid");
        //console.log(localStorage.getItem('user_qa_gcid'));
        return localStorage.getItem('user_qa_gcid');
    }

    setAirplaneMode(isOn){
        localStorage.setItem('airplaneMode', isOn);
    }

    getAirplaneMode(){
        var airplaneModeString = localStorage.getItem('airplaneMode');
        return  (airplaneModeString === 'true');
    }

    saveLocalOrgConfig(gcid, orgConfig){
        localStorage.setItem("orgconfig-" + gcid, compress(JSON.stringify(orgConfig)));
    }

    getLocalOrgConfig(gcid){
        return JSON.parse(decompress(localStorage.getItem("orgconfig-" + gcid)));
    }

    hasLocalOrgConfig(gcid){
        return this.keyExists("orgconfig-" + gcid);
    }

    getLocalAddressBook(gcid, userId){
        return JSON.parse(decompress(localStorage.getItem("addressbook-" + gcid + '-' + userId)));
    }

    saveLocalAddressBook(gcid, userId, addressBook){
        localStorage.setItem("addressbook-" + gcid + '-' + userId, compress(JSON.stringify(addressBook)));  
    }

    hasLocalAddressBook(gcid, userId){
        return this.keyExists("addressbook-" + gcid + '-' + userId);
    }




    saveLocalSchema(schemaId, schema){
        // TBD - not saving by version!
        localStorage.setItem(schemaId + "-schema", compress(JSON.stringify(schema)));
    }

    getLocalSchema(schemaId){
        var result =  JSON.parse(decompress(localStorage.getItem(schemaId + "-schema")));
        return result;
    }

    saveLocalGridSchema(schemaId, gridSchema){
        localStorage.setItem(schemaId + "-gridschema", compress(JSON.stringify(gridSchema))); 
    }

    getLocalGridSchema(schemaId){
        //console.group("getLocalGridSchema: ");
        //console.log(schemaId);
        return {data: JSON.parse(decompress(localStorage.getItem(schemaId + "-gridschema")))};  
        //console.groupEnd();
    }

    saveLocalObservation(gcid, schemaId, offlineObservation){
        localStorage.setItem("obs-" + gcid + "-" + schemaId + "-" + offlineObservation.offLineId, compress(JSON.stringify(offlineObservation)));
    }

    getLocalObservations(gcid, schemaId){
        var result = [];
        for (var key in localStorage){
            if (key.startsWith("obs-" + gcid + "-" + schemaId + "-")){
                var obs = JSON.parse(decompress(localStorage[key]));
                result.push(obs.observation);
            }
        }
        //console.log(result);
        return result;
    }

    localSuspendedObservationKey(gcid, schemaId, userId)
    {
        return "suspended~" + gcid + "~" + schemaId + "~" + userId;
    }

    saveLocalSuspendedObservation(gcid, schemaId, userId, valueBag)
    {
        localStorage.setItem(this.localSuspendedObservationKey(gcid,schemaId, userId), compress(JSON.stringify(valueBag)));
    }

    hasLocalSuspendedObservation(gcid, schemaId, userId)
    {
        return this.keyExists(this.localSuspendedObservationKey(gcid, schemaId, userId));
    }

    getLocalSuspendedObservation(gcid, schemaId, userId)
    {
        var result =  JSON.parse(decompress(localStorage.getItem(this.localSuspendedObservationKey(gcid, schemaId, userId))));
        return result;
    }

    removeLocalSuspendedObservation(gcid, schemaId, userId)
    {
        localStorage.removeItem(this.localSuspendedObservationKey(gcid, schemaId, userId));
    }

    removeAllLocalSuspendedObservations(gcid, userId)
    {
        var result = [];
        for (var key in localStorage){
            if (key.startsWith("suspended~" + gcid))
            {   
                var keyTokens = key.split("~");
                if (keyTokens[keyTokens.length-1] === userId) 
                {    
                    result.push(key);
                }
            }
        }
        if ((!result) || (result.length < 1)) return;
        result.forEach((ky) => 
        {
            localStorage.removeItem(ky);    
        })
    }






    setFullSchema(fullSchema){
        localStorage.setItem(fullSchema.id + fullSchema.schemaVersion, JSON.stringify(fullSchema));
    }

    getFullSchema(id, version){
        return JSON.parse(localStorage.getItem(id + version));
    }

    setSchema(schema){
        localStorage.setItem(this.getGcid() + "::currentschema", JSON.stringify(schema));
    }

    getSchema(){
        return JSON.parse(localStorage.getItem(this.getGcid() + "::currentschema"));
    }


    setMainFilter(searchParams){
        console.log("Search Param Change: ");
        console.log(searchParams);
        localStorage.setItem(this.getGcid() + "::searchparams", JSON.stringify(searchParams));
    }

    getMainFilter(){
        return JSON.parse(localStorage.getItem(this.getGcid() + "::searchparams"));
    }

    clearMainFilter(){
        localStorage.removeItem(this.getGcid() + "::searchparams");
    }


    setUserProp(propKy, propVal){
        var ky = this.getGcid() + ":" + this.getUser() + ":" + propKy;
        localStorage.setItem(ky, propVal);
    }

    getUserProp(propKy){
        var ky = this.getGcid() + ":" + this.getUser() + ":" + propKy;
        return localStorage.getItem(ky);
    }





    setToken(idToken) {
        // Saves user token to localStorage
        localStorage.setItem('id_token', idToken)
    }

    getToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem('id_token')
    }



    logout() {
        // Clear user token and profile data from localStorage
        localStorage.removeItem('id_token');
    }

    getProfile() {
        // Using jwt-decode npm package to decode the token
        var token = this.getToken();
        var result = decode(token);
        return result;
    }


    fetch(url, options, overrideHeaders) {
        // performs api calls sending the required authentication headers
        const headers =  overrideHeaders || {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => response.json())
    }


}